import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AppConfig } from 'app/app.config';
import { ClickableBoxComponent } from 'app/components/common/clickableBox/clickableBox.component';
import { ClickableBoxListComponent } from 'app/components/common/clickableBox/clickableBoxList.component';
import { DateTimePickerComponent } from 'app/components/common/dateTimePicker/dateTimePicker.component';
import { DevicesStatusTableComponent } from 'app/components/common/deviceStatusTable/devicesStatusTable.component';
import { DropDownComponent } from 'app/components/common/dropdown/dropdown.component';
import { FileSelectorComponent } from 'app/components/common/fileSelector/fileSelector.component';
import { HeaderWithRouteComponent } from 'app/components/common/headerWithRoute/headerWithRoute.component';
import { JsonEditorComponent } from 'app/components/common/jsonEditor/jsonEditor.component';
import { SpinnerBase } from 'app/components/common/spinners/spinnerBase.component';
import { WaveSpinnerComponent } from 'app/components/common/spinners/waveSpinner.component';
import { TagComponent } from 'app/components/common/tag/tag.component';
import { ToggleSwitchComponent } from 'app/components/common/toggleSwitch/toggleSwitch.component';
import { PendingChangesGuard } from 'app/components/guards/pendingChanges.guard';
import { LoginFormComponent } from 'app/components/loginForm/loginForm.component';
import { BasicModalComponent } from 'app/components/modal/basicModal.component';
import { DeleteModalComponent } from 'app/components/modal/deleteModal.component';
import { ModalModule } from 'app/components/modal/modal.module';
import { ReauthModalComponent } from 'app/components/modal/reauthModal.component';
import { UnlinkDeviceModalComponent } from 'app/components/modal/unlinkDeviceModal.component';
import { ReauthenticateFormComponent } from 'app/components/reauthenticateForm/reauthenticateForm.component';
import { Globals } from 'app/globals/globals';
import { PipesModule } from 'app/pipes/pipes.module';
import { ModalService } from 'app/services/modal.service';
import { LoggerFactory } from 'app/shared/loggerFactory';
import { EditScheduleEntryModalComponent } from 'app/views/devices/editScheduleEntryModal/editScheduleEntryModal.component';
import { DeleteGroupModalComponent } from 'app/views/devices/groups/deleteGroupModal.component';
import { BsDatepickerModule, TimepickerModule } from 'ngx-bootstrap';
import { Sleep } from '../services/sleep';
import { LoadImage } from './../services/loadImage';
import { FieldValidationComponent } from './common/fieldValidation/fieldValidation.component';

@NgModule({
    entryComponents: [
        DeleteModalComponent,
        DeleteGroupModalComponent,
        UnlinkDeviceModalComponent,
        EditScheduleEntryModalComponent,
        ReauthModalComponent,
        BasicModalComponent
    ],
    imports: [
        CommonModule,
        PipesModule,
        TranslateModule,
        FormsModule,
        RouterModule,
        ModalModule,
        FormsModule,
        ReactiveFormsModule,
        BsDatepickerModule,
        TimepickerModule
    ],
    exports: [
        ReauthModalComponent,
        HeaderWithRouteComponent,
        LoginFormComponent,
        FileSelectorComponent,
        JsonEditorComponent,
        ReauthenticateFormComponent,
        SpinnerBase,
        WaveSpinnerComponent,
        ClickableBoxComponent,
        ClickableBoxListComponent,
        TagComponent,
        ToggleSwitchComponent,
        DropDownComponent,
        DeleteModalComponent,
        DeleteGroupModalComponent,
        UnlinkDeviceModalComponent,
        DateTimePickerComponent,
        EditScheduleEntryModalComponent,
        BasicModalComponent,
        TimepickerModule,
        DevicesStatusTableComponent,
        FieldValidationComponent
    ],
    declarations: [
        ReauthModalComponent,
        HeaderWithRouteComponent,
        LoginFormComponent,
        FileSelectorComponent,
        FieldValidationComponent,
        JsonEditorComponent,
        ReauthenticateFormComponent,
        SpinnerBase,
        WaveSpinnerComponent,
        ClickableBoxComponent,
        ClickableBoxListComponent,
        TagComponent,
        DeleteModalComponent,
        DeleteGroupModalComponent,
        UnlinkDeviceModalComponent,
        ToggleSwitchComponent,
        DropDownComponent,
        DateTimePickerComponent,
        EditScheduleEntryModalComponent,
        BasicModalComponent,
        DevicesStatusTableComponent
    ],
    providers: [
        Globals
    ]
})
export class SharedModule {
    public static forRoot(): ModuleWithProviders {
        return {
            ngModule: SharedModule,
            providers: [
                Globals,
                PendingChangesGuard,
                LoggerFactory,
                Globals,
                AppConfig,
                Sleep,
                LoadImage
            ]
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/components/shared.module.ts